import { apiUrls } from 'src/utils/properties';
import { EstimatedWaitingTime, StudentStatus } from 'src/models/AskForHelp';
import api, { Method } from 'src/utils/apiManager.utils';

const getConnectionStatus = async (activityId: string) => {
  return new Promise((resolve, reject) => {
    api(
      Method.GET,
      null,
      apiUrls.ASK_FOR_HELP + apiUrls.STUDENT + apiUrls.CONNECTION_STATUS,
      '',
      '',
      activityId
    )
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getEstimatedWaitingTime = async (
  id: string
): Promise<EstimatedWaitingTime> => {
  return new Promise((resolve, reject) => {
    api(
      Method.GET,
      null,
      apiUrls.ASK_FOR_HELP + apiUrls.STUDENT + apiUrls.ESTIMATED_MEETING_TIME,
      '',
      '',
      id
    )
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getStudentStatus = async (): Promise<StudentStatus> => {
  return new Promise((resolve, reject) => {
    api(
      Method.GET,
      null,
      apiUrls.ASK_FOR_HELP + apiUrls.STUDENT + apiUrls.STATUS,
      '',
      '',
      ''
    )
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const requestMeeting = async (activityId: string) => {
  return new Promise((resolve, reject) => {
    api(
      Method.POST,
      null,
      apiUrls.ASK_FOR_HELP + apiUrls.STUDENT + apiUrls.MEETING_REQUEST,
      '',
      '',
      activityId
    )
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const cancelMeetingRequest = async (activityId: string) => {
  return new Promise((resolve, reject) => {
    api(
      Method.PUT,
      null,
      apiUrls.ASK_FOR_HELP + apiUrls.STUDENT + apiUrls.MEETING_CANCEL_REQUEST,
      '',
      '',
      activityId
    )
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const joinMeeting = async (id: string) => {
  return new Promise((resolve, reject) => {
    api(
      Method.GET,
      null,
      apiUrls.ASK_FOR_HELP + apiUrls.STUDENT + apiUrls.JOIN_MEETING,
      '',
      '',
      id
    )
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const removeStudentFromQueue = async () => {
  return new Promise((resolve, reject) => {
    api(
      Method.PUT,
      null,
      apiUrls.ASK_FOR_HELP + apiUrls.STUDENT + apiUrls.REMOVE_USER_FROM_QUEUE,
      '',
      '',
      ''
    )
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const removeTeacherFromQueue = async (id: string) => {
  return new Promise((resolve, reject) => {
    api(
      Method.PUT,
      null,
      apiUrls.ASK_FOR_HELP + apiUrls.TEACHER + apiUrls.REMOVE_USER_FROM_QUEUE,
      '',
      '',
      id
    )
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getTeacherById = async () => {
  return new Promise((resolve, reject) => {
    api(
      Method.GET,
      null,
      apiUrls.ASK_FOR_HELP + apiUrls.STUDENT + apiUrls.TEACHER,
      '',
      '',
      ''
    )
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export {
  getConnectionStatus,
  getEstimatedWaitingTime,
  requestMeeting,
  cancelMeetingRequest,
  getStudentStatus,
  joinMeeting,
  getTeacherById,
  removeStudentFromQueue,
  removeTeacherFromQueue
};
